// extracted by mini-css-extract-plugin
export default {"container":"Preguntas_container__MDmMU","title":"Preguntas_title__h45eZ","subTitle":"Preguntas_subTitle__EaZPK","box":"Preguntas_box__5tzaq"};